import { render, staticRenderFns } from "./RenameFolder.vue?vue&type=template&id=627ca8d8"
import script from "./RenameFolder.vue?vue&type=script&setup=true&lang=js"
export * from "./RenameFolder.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RenameFolder.vue?vue&type=style&index=0&id=627ca8d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports